import { ProductProcessingStatus } from '@/constants/productProcessingType'
import type { Product } from '@/types/product'
import api from '@/api'

interface ProductData {
  id: number
  imageLink?: string | null
  additionalImageLink?: string | null
  remBgUrls?: string
  parentCategory: string
  parentProductName: string
  weightInGrams: string
  unitOfMeasure: string
  volumeInCC: string
  metadata: string
  brand: string
}

class ProductService {
  getProducts = async (bpId: number | null, brandName: string): Promise<Product[]> => {
    const response = await api.get<{ data: { products: ProductData[] } }>(`businessProfiles/${bpId}/products`, {
      'filterGroups[0].Filters[0].Field': 'brand',
      'filterGroups[0].Filters[0].Condition': 'Equals',
      'filterGroups[0].Filters[0].Values[0]': brandName,
      'filterGroups[1].Filters[0].Field': 'FeedProcessorStatus',
      'filterGroups[1].Filters[0].Condition': 'Equals',
      'filterGroups[1].Filters[0].Values[0]': String(ProductProcessingStatus.ReadyForUpload),
    })

    const productsData: ProductData[] = response.data.products
    const products: Product[] = []

    productsData.forEach((product) => {
      const originalUrls: string[] = []
      const remBgUrls: string[] = []

      if (product.imageLink) {
        originalUrls.push(product.imageLink)
      }

      if (product.additionalImageLink) {
        try {
          const additional = JSON.parse(product.additionalImageLink)
          if (Array.isArray(additional)) {
            originalUrls.push(...additional)
          }
        } catch (err) {
          console.error('Failed to parse additionalImageLink:', err)
        }
      }

      if (product.remBgUrls) {
        try {
          const parsedRemBg = JSON.parse(product.remBgUrls)
          if (parsedRemBg.imageLink) {
            remBgUrls.push(parsedRemBg.imageLink)
          }
          if (Array.isArray(parsedRemBg.additionalImageLink)) {
            remBgUrls.push(...parsedRemBg.additionalImageLink)
          }
        } catch (err) {
          console.error('Failed to parse remBgUrls:', err)
        }
      }

      originalUrls.forEach((url) => {
        products.push({
          id: product.id,
          productUrl: url,
          loading: false,
          parentCategory: product.parentCategory,
          parentProductName: product.parentProductName,
          weightInGrams: product.weightInGrams,
          unitOfMeasure: product.unitOfMeasure,
          volumeInCC: product.volumeInCC,
          metaData: product.metadata,
          brand: product.brand,
        })
      })
    })

    return products
  }
}

export default ProductService
